import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import GoRedirectPage from './GoRedirectPage';

const GoRedirectRoute: FuseRouteItemType[] = [
  {
    path: '/golink/*',
    element: <GoRedirectPage />,
    auth: null,
  },
];

export default GoRedirectRoute;
